import { useState, useEffect, useCallback } from 'react';
import { REACT_APP_DISCORD_BOT_ENDPOINT } from '../config/constants';

export default function UpdatesWordPressForm({ authToken }) {
  const [planType, setPlanType] = useState('');
  // Estados comuns
  const [submitted, setSubmitted] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  
  // Opções de atualização
  const [updateCore, setUpdateCore] = useState(true);
  const [updatePlugins, setUpdatePlugins] = useState(true);
  const [updateTheme, setUpdateTheme] = useState(false);

  // --- Lightsail ---
  const [lightsailList, setLightsailList] = useState([]);
  const [loadingLightsail, setLoadingLightsail] = useState(false);
  const [selectedLightsail, setSelectedLightsail] = useState('');

  // --- Shared ---
  const [sharedList, setSharedList] = useState([]);
  const [loadingShared, setLoadingShared] = useState(false);
  const [selectedShared, setSelectedShared] = useState('');
  const [selectedHost, setSelectedHost] = useState('');
  const shareds = [
    { text: 'aws-shared-2', value: 'aws-shared-2' },
    { text: 'aws-shared-3', value: 'aws-shared-3' },
    { text: 'aws-shared-4', value: 'aws-shared-4' },
  ];

  // --- Private (EC2) ---
  const [ec2List, setEc2List] = useState([]);
  const [loadingEc2, setLoadingEc2] = useState(false);
  const [selectedEc2, setSelectedEc2] = useState('');

  // --- Funções de carregamento (definidas antes do useEffect) ---
  const loadLightsailList = useCallback(async () => {
    setLoadingLightsail(true);
    try {
      const response = await fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({ command: 'aws', function: 'listAllLightsail' })
      });
      const data = await response.json();
      const ResourcesList = [];
      data.forEach(e => {
        const ls = { text: e.name, value: `${e.name}|${e.bundleId}|${e.arn}` };
        ResourcesList.push(ls);
      });
      ResourcesList.sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'));
      setLightsailList(ResourcesList);
    } catch {
      setLightsailList([]);
    } finally {
      setLoadingLightsail(false);
    }
  }, [authToken]);

  const loadEc2List = useCallback(async () => {
    setLoadingEc2(true);
    try {
      const response = await fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({ command: 'aws', function: 'listAllEC2' })
      });
      const data = await response.json();
      const ResourcesList = [];
      data.forEach(e => {
        let _resource;
        const hostName = e[0].Tags.filter(e => e.Key === 'host');
        const workspace = e[0].Tags.filter(e => e.Key === 'workspace');
        const product = e[0].Tags.filter(e => e.Key === 'product');
        const act = e[0].Tags.filter(e => e.Key === 'act');
        if (workspace.length !== 0 && workspace[0].Value === 'internal') return;
        if (product.length !== 0 && product[0].Value === 'wphost-shared') return;
        if (hostName.length === 0) {
          _resource = {
            text: `${e[0].InstanceId}`,
            value: `${e[0].InstanceId}|${e[0].InstanceType}|${e[0].Architecture}`
          };
        } else {
          const actFilter = act.length !== 0 ? `${act[0].Value}.` : '';
          _resource = {
            text: `${actFilter}${hostName[0].Value} - ${e[0].InstanceId}`,
            value: `${e[0].InstanceId}|${e[0].InstanceType}|${e[0].Architecture}|${hostName[0].Value}`
          };
        }
        ResourcesList.push(_resource);
      });
      ResourcesList.sort((a, b) => a.text.localeCompare(b.text, 'pt-BR'));
      setEc2List(ResourcesList);
    } catch {
      setEc2List([]);
    } finally {
      setLoadingEc2(false);
    }
  }, [authToken]);

  async function loadHostsList(shared) {
    setLoadingShared(true);
    try {
      const response = await fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({ command: 'opt', function: 'list-hosts-shareds', shared })
      });
      const data = await response.json();
      setSharedList(data);
    } catch {
      setSharedList([]);
    } finally {
      setLoadingShared(false);
    }
  }

  // Carregar listas ao trocar tipo
  useEffect(() => {
    if (planType === 'lightsail') loadLightsailList();
    if (planType === 'shared') setSharedList([]); // Limpa ao trocar
    if (planType === 'private') loadEc2List();
    // Limpa campos ao trocar
    setSubmitted(false);
    setResponseMsg('');
    setUpdateCore(true);
    setUpdatePlugins(true);
    setUpdateTheme(false);
    setSelectedLightsail('');
    setSelectedShared('');
    setSelectedHost('');
    setSelectedEc2('');
  }, [planType, loadLightsailList, loadEc2List]);

  // --- Submissão ---
  const handleSubmit = (e) => {
    e.preventDefault();
    let data = {};
    if (planType === 'lightsail') {
      data = {
        form: 'update_wordpress_lightsail',
        lightsail: selectedLightsail,
        updateCore,
        updatePlugins,
        updateTheme
      };
    } else if (planType === 'shared') {
      data = {
        form: 'update_wordpress_shared',
        shared: selectedShared,
        host: selectedHost,
        updateCore,
        updatePlugins,
        updateTheme
      };
    } else if (planType === 'private') {
      data = {
        form: 'update_wordpress_private',
        ec2: selectedEc2,
        updateCore,
        updatePlugins,
        updateTheme
      };
    }
    fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({ command: 'submit', data })
    })
      .then((res) => res.text())
      .then((msg) => {
        setSubmitted(true);
        setResponseMsg(msg);
      });
  };

  if (submitted) {
    let content;
    try {
      const parsed = JSON.parse(responseMsg);
      content = (
        <div className="json-response-list">
          {Object.entries(parsed).map(([key, value]) => (
            <div key={key} style={{ marginBottom: '0.5em' }}>
              <strong>{key}:</strong> <span>{String(value)}</span>
            </div>
          ))}
        </div>
      );
    } catch {
      content = <p>{responseMsg}</p>;
    }
    return (
      <div className="dynamic-form">
        <div className="success-message">
          {content}
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="dynamic-form">
      <div className="form-group">
        <label className="form-label">Tipo de Plano</label>
        <select value={planType} onChange={e => setPlanType(e.target.value)} className="form-select">
          <option value="">Selecione o tipo</option>
          <option value="lightsail">Lightsail</option>
          <option value="shared">Shared</option>
          <option value="private">Private</option>
        </select>
      </div>

      {/* Lightsail */}
      {planType === 'lightsail' && (
        <div style={{border: '1px solid #eee', padding: 16, borderRadius: 8, marginBottom: 16}}>
          <div className="form-group">
            <label className="form-label">Selecione um domínio</label>
            {loadingLightsail ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Carregando domínios...</p>
              </div>
            ) : (
              <select value={selectedLightsail} onChange={e => setSelectedLightsail(e.target.value)} className="form-select">
                <option value="">Selecione um domínio</option>
                {lightsailList.map((lightsail) => (
                  <option key={lightsail.value} value={lightsail.value}>{lightsail.text}</option>
                ))}
              </select>
            )}
          </div>
        </div>
      )}

      {/* Shared */}
      {planType === 'shared' && (
        <div style={{border: '1px solid #eee', padding: 16, borderRadius: 8, marginBottom: 16}}>
          <div className="form-group">
            <label className="form-label">Shared</label>
            <select value={selectedShared} onChange={e => { setSelectedShared(e.target.value); setSelectedHost(''); loadHostsList(e.target.value); }} className="form-select">
              <option value="">Selecione o Shared</option>
              {shareds.map((shared) => (
                <option key={shared.value} value={shared.value}>{shared.text}</option>
              ))}
            </select>
          </div>
          {loadingShared && (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Carregando hosts do Shared...</p>
            </div>
          )}
          {sharedList.length > 0 && (
            <div className="form-group">
              <label className="form-label">Domínio</label>
              <select value={selectedHost} onChange={e => setSelectedHost(e.target.value)} className="form-select">
                <option value="">Selecione um Domínio</option>
                {sharedList.map((shared) => (
                  <option key={shared.value} value={shared.value}>{shared.text}</option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}

      {/* Private */}
      {planType === 'private' && (
        <div style={{border: '1px solid #eee', padding: 16, borderRadius: 8, marginBottom: 16}}>
          <div className="form-group">
            <label className="form-label">Selecione um domínio</label>
            {loadingEc2 ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p className="loading-text">Carregando domínios...</p>
              </div>
            ) : (
              <select value={selectedEc2} onChange={e => setSelectedEc2(e.target.value)} className="form-select">
                <option value="">Selecione um domínio</option>
                {ec2List.map((ec2) => (
                  <option key={ec2.value} value={ec2.value}>{ec2.text}</option>
                ))}
              </select>
            )}
          </div>
        </div>
      )}

      {/* Opções de Atualização */}
      <div className="form-group">
        <label className="form-label">Atualizar:</label>
        
        <div className="form-group">
          <label className="form-label checkbox-label">
            <input
              type="checkbox"
              checked={updateCore}
              onChange={e => setUpdateCore(e.target.checked)}
              className="form-checkbox"
            />
            <span className="checkbox-text">Core</span>
          </label>
        </div>

        <div className="form-group">
          <label className="form-label checkbox-label">
            <input
              type="checkbox"
              checked={updatePlugins}
              onChange={e => setUpdatePlugins(e.target.checked)}
              className="form-checkbox"
            />
            <span className="checkbox-text">Plugins</span>
          </label>
        </div>

        <div className="form-group">
          <label className="form-label checkbox-label">
            <input
              type="checkbox"
              checked={updateTheme}
              onChange={e => setUpdateTheme(e.target.checked)}
              className="form-checkbox"
            />
            <span className="checkbox-text">Tema</span>
          </label>
        </div>
      </div>

      <div className="form-actions">
        <button 
          type="submit" 
          disabled={
            !planType ||
            (planType === 'lightsail' && !selectedLightsail) ||
            (planType === 'shared' && (!selectedShared || !selectedHost)) ||
            (planType === 'private' && !selectedEc2) ||
            (!updateCore && !updatePlugins && !updateTheme)
          }
          className="submit-button"
        >
          Continuar
        </button>
      </div>
    </form>
  );
}

